<template>
  <v-input hide-details class="mt-0">
    <template #prepend>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon class="mt-n1" v-bind="attrs" v-on="on">
            <v-icon v-if="mode === inputModes.Telephone">mdi-phone</v-icon>
            <v-icon v-else>mdi-whatsapp</v-icon>
            <v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="mode = inputModes.Telephone">
            <v-list-item-title>Telèfono</v-list-item-title>
          </v-list-item>
          <v-list-item @click="mode = inputModes.WhatsApp">
            <v-list-item-title>WhatsApp</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    <template #default>
      <vue-tel-input-vuetify
        class="mt-n4 mb-n3"
        :label="mode === inputModes.Telephone ? 'Telèfono' : 'WhatsApp'"
        @input="phoneChanged"
        :rules="required ? $rule('required') : undefined"
        v-model="number"
        placeholder=""
        :default-country="defaultCountry"
      />
    </template>
  </v-input>
</template>

<script lang="ts">
  import { Component, Vue, Prop, Model, Watch } from 'vue-property-decorator';

  export enum InputMode {
    Telephone,
    WhatsApp,
  }

  @Component
  export default class TelephoneInput extends Vue {
    @Prop() defaultCountry: string;
    @Prop({ default: true }) required: boolean;
    @Prop() value: string;
    @Prop() modeValue?: InputMode;
    inputModes = InputMode;
    mode: InputMode = InputMode.Telephone;
    number: string = null;

    async created() {}

    @Watch('value', { immediate: true })
    onValueChanged() {
      if (typeof this.value === 'string') {
        this.number = this.value;
      }
    }

    @Watch('modeValue', { immediate: true })
    onModeChanged() {
      if (this.modeValue !== undefined) {
        this.mode = this.modeValue;
      }
    }

    phoneChanged(e, data) {
      this.$emit('change', { type: this.mode, number: data.number.e164 });
    }
  }
</script>
